<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f018-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">The structure carrying the winding gear of Puits 15 at the northern end of the Loos Crassier spoil heap, known universally to the troops as ‘Tower Bridge’</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 27_fm0310.vue?6dd3f2bc